// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Congrats_wrapper__2m73m","img":"Congrats_img__28kI7","text":"Congrats_text__Vfzvz"};